import Hero from "../components/Hero";
import { useNavigate } from "react-router-dom";
import HeroImage from "../../assets/images/teachers_image001.png";
import mortageImage2 from "../../assets/images/Mortgage2.jpg";
import mortageImage3 from "../../assets/images/Mortgage3.jpg";
import mortageImage4 from "../../assets/images/teachers_image002.png";
import Accordion from "../designSystem/Accordion";
import { ReactComponent as Step1Icon } from "../../assets/icons/Mortgage1.svg";
import { ReactComponent as Step2Icon } from "../../assets/icons/Mortgage2.svg";
import { ReactComponent as Step3Icon } from "../../assets/icons/Mortgage3.svg";
import { ReactComponent as Step4Icon } from "../../assets/icons/Mortgage4.svg";
import { ReactComponent as Step5Icon } from "../../assets/icons/Mortgage5.svg";
import FeatureCards from "../designSystem/FeatureCards";
import FilledButton from "../designSystem/FilledButton";
import Card from "../designSystem/Card";
import MichaelImage from "../../assets/images/OurTeam2.jpg";
import OutlinedButton from "../designSystem/OutlinedButton";

const mortgageSteps = [
  {
    icon: Step1Icon,
    title: "Borrowing",
  },
  {
    icon: Step2Icon,
    title: "First Time Buyers",
  },
  {
    icon: Step3Icon,
    title: "Protection",
  },
  {
    icon: Step4Icon,
    title: "Moving Home",
  },
  {
    icon: Step5Icon,
    title: "Remortgaging",
  },
];

const partnerInSuccess = [
  {
    title: "First-Time Buyer",
    content:
      "Taking your first step onto the property ladder can feel daunting. We can help you understand your borrowing options, explain the process and find a mortgage that suits your circumstances.",
  },
  {
    title: "Moving Home",
    content:
      "If you're looking to move, we'll help you understand how much you could borrow and guide you through your mortgage options, whether you're buying a larger home or simply looking for a change.",
  },
  {
    title: "Remortgaging",
    content:
      "Your current mortgage may no longer be the most suitable option. We can review your circumstances and help you explore your remortgage options, including whether you could secure a more suitable deal.",
  },
  {
    title: "Your Borrowing Options",
    content:
      "Every teacher's circumstances are different. We can help you understand how your income and financial position could affect your borrowing capacity, giving you a clearer idea of what may be achievable.",
  },
  {
    title: "Protection",
    content:
      "Your mortgage is likely to be one of your biggest financial commitments. We can also help you consider Life Insurance, Critical Illness Cover and Income Protection to help protect you and your family if your circumstances change.",
  },
];

const MortgageAdviceForTeachersPage = () => {
  const navigate = useNavigate();
  return (
    <div className="home-page">
      <Hero
        title="Mortgages"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <section className="white-container">
        <div className="grey-container-content">
          <div className="row">
            <div className="content-column">
              <h2 className="burgandy align-left">
                Expert mortgage advice, tailored to the teaching profession.
              </h2>
              <div className="divider burgandy align-left" />
              <div className="content grey align-left">
                Whether you're buying your first home, moving house or
                remortgaging, WPP Financial Services provides straightforward
                mortgage advice tailored to teachers and their individual
                circumstances.
              </div>
              <div className="content-semibold grey align-left">
                We understand that teaching is a demanding profession, with busy
                schedules and limited free time. That's why we work around your
                availability and aim to make the mortgage process as simple,
                clear and hassle-free as possible.
              </div>
              <div className="help_text grey align-left">
                Your home may be repossessed if you do not keep up repayments,
                Larger deposits usually mean better rates, Mortgage terms and
                types should match your financial situation, Always consider
                fees, interest rates, and long-term affordability.
              </div>
            </div>
            <img
              src={mortageImage4}
              alt="Expert mortgage advice for teachers"
              className="image-container"
            />
          </div>
        </div>
      </section>
      <section className="grey-container">
        <div className="grey-container-content">
          <div className="column">
            <FeatureCards features={mortgageSteps} />
          </div>
        </div>
      </section>
      <section className="burgandy-container">
        <div className="burgandy-container-content">
          <div className="cards-wrapper teacher-cards-wrapper">
            {partnerInSuccess.map((t, idx) => (
              <Card key={idx} {...t} />
            ))}
          </div>
        </div>
      </section>
      <div className="white-container">
        <div className="white-container-content">
          <div className="row">
            <img
              src={MichaelImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
            <div className="content-column">
              <h2 className="burgandy align-left">Michael Welton</h2>
              <div className="row">
                <FilledButton
                  text="07791 445522"
                  onClick={() => window.open("tel:07791445522", "_self")}
                />
                <FilledButton
                  text="michael@wppfs.co.uk"
                  onClick={() =>
                    window.open("mailto:michael@wppfs.co.uk", "_self")
                  }
                />
              </div>
              <div className="content-semibold grey align-left">
                Michael Welton | Managing Director | Residential, Remortgage &
                Purchase Specialist
              </div>
              <div className="content grey align-left">
                Michael has worked in financial services since 2003, including
                roles with Woolwich, Barclays and St James’s Place.
              </div>
              <div className="content grey align-left">
                He prides himself on providing straightforward,
                easy-to-understand advice and making the mortgage process as
                simple as possible. With extensive experience in residential
                mortgages, remortgages and purchases, Michael understands the
                importance of giving clear advice that fits around your
                circumstances.
              </div>
              <OutlinedButton
                text="Book a FREE initial appointment"
                onClick={() => {
                  window.open(
                    "https://calendly.com/michaelweltonmortgageadvice/30min",
                    "_blank",
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MortgageAdviceForTeachersPage;
